import React from 'react';
import { useHistory } from 'react-router-dom';
import { formatFullLocation } from "utils";
import { Location } from "components/BillingLocationSelector";
import { Subtitle, SubtitleSecondary, Title, TitleContainer, JobTitleButton, MenuOutlinedIconStyled } from "./JobTitle.styles";
import { BackendJob } from "components/EditJob";
import Api from "api";

interface JobTitleProps {
    title: string;
    practiceName?: string;
    location?: Location;
    job?: BackendJob;
}

const JobTitle: React.FC<JobTitleProps> = ({title, practiceName, location, job}) => {
    const history = useHistory();

    const handleJobDetailsClick = async () => {
        if (job && job.id) {
            try {
                const hireJob = await Api.getHireJob(job.id);
                if (hireJob) {
                    history.push('jobInfo', { job: hireJob });
                } else {
                    console.error("Job not found in the list of hire jobs");
                }
            } catch (error) {
                console.error("Error fetching job details:", error);
            }
        }
    };

    return (
        <TitleContainer>
            <Title>{title}</Title>
            {practiceName && <Subtitle>{practiceName}</Subtitle>}
            {location && <SubtitleSecondary>{formatFullLocation(location)}</SubtitleSecondary>}
            {job && <JobTitleButton 
                variant="outlined"
                color="primary"
                size="large"
                id="signup-button"
                onClick={handleJobDetailsClick}
                disabled={!job}
            >
                <MenuOutlinedIconStyled />
                Job Details
            </JobTitleButton>}
        </TitleContainer>
    );
}

export default JobTitle;